import moment from 'moment';
import { alertError } from 'services/alerts';
import { paymentApi } from 'src/services/http';
import i18n from 'src/i18n';
import {
  RECEPTION_BANK_CONTACT,
  RECEPTION_CARD,
  RECEPTION_CASH,
  RECEPTION_INVOICE,
  RECEPTION_DEBT,
  RECEPTION_WORK_ACCIDENT,
  RECEPTION_HOSPITAL_ADMISSION,
  PRO_DEO,
  IN_APP_PAYMENT
} from 'services/constants';

export const getTransactionsList = invoiceId => {
  return paymentApi.get(`/invoices/${invoiceId}/transactions`).then(
    res => {
      if (res && res.data) {
        return res.data.sort(
          (a, b) => (moment(a.createdDateTime).isBefore(moment(b.createdDateTime)) ? 1 : -1)
        );
      }
    },
    () => {
      alertError();
    }
  );
};

// ──── highlight cell ────────────────────────────────────────────────────────────────────

export const highlightStatusList = ['default', 'paid', 'cancel'];

const getTransactionOption = (transaction, target) =>
  transaction && transaction[target] ? String(transaction[target]) : null;

export const highlightCellFromStatus = transaction => {
  const statusCode = getTransactionOption(transaction, 'paymentStatus');

  // track from status code
  switch (statusCode) {
    // paid
    case '100':
      return highlightStatusList[1];
    // cancel | denied
    case '-60':
    case '-90':
    case '-63':
    case '-64':
      return highlightStatusList[2];
    default:
      return highlightStatusList[0];
  }
};

export const translateTransactionStatus = transaction => {
  let translateKey = '';
  const statusCode = getTransactionOption(transaction, 'paymentStatus');

  // track from status code
  switch (statusCode) {
    // cancel
    case '-60':
    case '-90':
      translateKey = 'status_cancel';
      break;
    // expired
    case '-80':
      translateKey = 'status_expired';
      break;
    // refund
    case '-81':
      translateKey = 'status_refund';
      break;
    // pending
    case '20':
    case '25':
    case '50':
    case '90':
      translateKey = 'status_pending';
      break;
    // verify
    case '85':
      translateKey = 'status_verify';
      break;
    // authorize
    case '95':
      translateKey = 'status_authorize';
      break;
    // paid
    case '100':
      translateKey = 'status_paid';
      break;
    // denied
    case '-63':
    case '-64':
      translateKey = 'status_denied';
      break;
  }

  return translateKey ? i18n.t(translateKey) : null;
};

const paymentMethodsList = [
  { type: RECEPTION_BANK_CONTACT, translateLabel: ['value_bancontact'] },
  { type: RECEPTION_CARD, translateLabel: ['value_visa', 'value_mastercard'] },
  { type: RECEPTION_CASH, translateLabel: ['value_cash'] },
  { type: RECEPTION_INVOICE, translateLabel: ['value_invoice'] },
  {
    type: RECEPTION_DEBT,
    translateLabel: ['value_ocmw', 'value_debt_mediation']
  },
  { type: RECEPTION_WORK_ACCIDENT, translateLabel: ['value_work_accident'] },
  { type: PRO_DEO, translateLabel: ['prodeo_invoice'] },
  { type: IN_APP_PAYMENT, translateLabel: ['inapp_in_invoice'] },
  { type: RECEPTION_HOSPITAL_ADMISSION, translateLabel: ['value_hospital_admission'] }
];

export const translatePayMethod = payMethod => {
  if (payMethod) {
    const translateObj = paymentMethodsList.find(
      el => String(el.type).toLowerCase() === String(payMethod).toLowerCase()
    );
    if (
      translateObj &&
      typeof translateObj.translateLabel === 'object' &&
      translateObj.translateLabel.length > 0
    ) {
      return translateObj.translateLabel.map(tr => i18n.t(tr)).join(' ');
    }
    return null;
  }
  return null;
};
